import React from 'react';
import Hypertension from './Hypertension';
import Diabetes from './Diabetes';
import Dyslipidemia from './Dyslipidemia';
import Imc from './Imc';

const ResultsTable = ({ examsObj }) => {
    return (
        <>
            {examsObj.pathologyName === 'Hipertensión' ? (
                <>
                    <Hypertension
                        exams={examsObj.examsArray}
                    />
                </>
            ) : null}
            {examsObj.pathologyName === 'Diabetes' || examsObj.pathologyName === 'Pre diabetes' ? (
                <>
                    <Diabetes
                        exams={examsObj.examsArray}
                    />
                </>
            ) : null}
            {examsObj.pathologyName === 'Dislipidemia' ? (
                <>
                    <Dyslipidemia
                        exams={examsObj.examsArray}
                    />
                </>
            ) : null}
            {examsObj.pathologyName === 'Obesidad' ? (
                <>
                    <Imc
                        exams={examsObj.examsArray}
                    />
                </>
            ) : null}
        </>
    );
}

export default ResultsTable;